import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { LiveProductsHeading } from "../../../Constant";
import { PRODUCT_CHARTS_DATA } from "../../../Data/Widgets/ChartWidgets";

const LiveProducts = () => {
  return (
    <Col xl="7" lg="12" className="xl-50">
      <div className="small-chart-widget chart-widgets-small">
        <Card>
          <CommonCardHeader title={LiveProductsHeading} className="border-bottom-1" />
          <CardBody>
            <div className="chart-container">
              <Row>
                <Col xs="12">
                  <ReactApexChart options={PRODUCT_CHARTS_DATA} series={PRODUCT_CHARTS_DATA.series} type="area" id="chart-widget6" height={320}/>
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>
      </div>
    </Col>
  );
};

export default LiveProducts;
